import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/config/config.service';
import { GoogleTagManagerService, ThemeService } from '@cudirect/shared-ui-library';
import { LenderService } from '@shared/service/lender/lender.service';
import { LenderConfiguration } from '@shared/model/lender-config.model';

/**
 * Initializer Lender data after getting lender config
 */
@Injectable({
  providedIn: 'root'
})
export class InitializeLenderService {
  constructor(
    private readonly lenderService: LenderService,
    private readonly appConfigService: AppConfigService,
    private readonly gtm: GoogleTagManagerService,
    private readonly themeService: ThemeService
  ) {}

  /**
   * Sets the lender-specific configurations such as theme settings and analytics.
   *
   * @param lenderDataInfo - Contains the lender's configuration such as theme colors, ADA level, and logo URL.
   */
  public async setLenderConfigData(lenderDataInfo: LenderConfiguration): Promise<void> {
    try {
      // Get app config - note that we can capture the resulting config here if it's needed in this method
      await this.appConfigService.get().toPromise();

      // This is overridden elsewhere in the application, but it gives us a baseline
      this.lenderService.lenderConfigData = lenderDataInfo;
      this.themeService.setTheme(lenderDataInfo.mainColor, lenderDataInfo.adaLevel || 'aa', lenderDataInfo.lenderLogoUrl);

      // Set Lender Specific GTM (Global DX GTM is set in index.html)

      // Read googleAnalytics object
      if (lenderDataInfo?.googleAnalytics) {
        // Check googleAnalytics object, if available then read the accountid value.
        const googleAnalysticsValue =
          lenderDataInfo?.googleAnalytics && lenderDataInfo?.googleAnalytics?.isEnabled === true
            ? lenderDataInfo?.googleAnalytics?.accountId
            : '';
        if (googleAnalysticsValue) {
          console.log('Added GA in Lender Initialization');
          this.gtm.addGA(googleAnalysticsValue);
        }
      }

      // Capture errors in the console if the lender config data is not set
    } catch (error) {
      console.error('Error setting lender config data:', error);
    }
  }
}
